const liveEnvironments = ['prod', 'test', 'beta', 'betatest', 'dev', 'sec'];
const currentEnvironment =
    process.env.REACT_APP_ENVIRONMENT?.toLowerCase() ?? 'local';

export const isLocalEnvironment =
    !liveEnvironments.includes(currentEnvironment);
